import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-landing-campana-ielectricistas',
  templateUrl: './landing-campana-ielectricistas.component.html',
  styleUrls: ['./landing-campana-ielectricistas.component.scss']
})
export class LandingCampanaIelectricistasComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
